import React from 'react';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import useCreditRepairExpertHook from './CreditRepairExpert.hook';
import CreditRepairExpertView from 'partial/OfferManager/modules/CreditRepairExpert/CreditRepairExpertView';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import ActionError from 'partial/OfferManager/modules/ActionError/ActionError';
import { getSimulationTrackingAttributes } from 'helpers/simulations.helper';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CREDIT_REPAIR_EXPERT } from 'partial/OfferManager/module.constants';
import { CREDIT_REPAIR_EXPERT_ACTION } from 'types/morph.pagePosition.constants';

const CreditRepairExpertViewController = props => {
  const atr = getViewModuleTrackingAttributes(
    CREDIT_REPAIR_EXPERT_ACTION,
    props.modulePosition,
  );

  const {
    error,
    loading,
    creditRepairExpertSim,
    homePageHandler,
    ...hookState
  } = useCreditRepairExpertHook();

  const simulationAttributes = getSimulationTrackingAttributes(
    CREDIT_REPAIR_EXPERT,
    {
      creditRepairExpertSim,
    },
  );

  const allAttr = { ...atr, ...simulationAttributes };
  useViewModule(allAttr);
  const seenPixel = useSeenModulePixel(allAttr);

  if (error) {
    return (
      <ActionError
        datatestid="creditRepairExpertError"
        error={error}
        homePageHandler={homePageHandler}
      />
    );
  } else if (loading) {
    return <LoadingSpinner />;
  } else {
    return (
      <CreditRepairExpertView
        offer={props.offers}
        pagePosition={CREDIT_REPAIR_EXPERT_ACTION}
        simulationResults={creditRepairExpertSim}
        simulationAttributes={simulationAttributes}
        seenPixel={seenPixel}
        {...hookState}
        {...props}
      />
    );
  }
};

export default CreditRepairExpertViewController;
